export default function() {
  if (!window.sdc) {
    return;
  }
  window.sdc.modalButtonOnClick = buttonElement => {
    const link = buttonElement.getAttribute('link');
    const channelId = buttonElement.getAttribute('channel-id');
    const appLink = buttonElement.getAttribute('app-link');
    const androidStoreLink = buttonElement.getAttribute('android-store-link');
    const iosStoreLink = buttonElement.getAttribute('ios-store-link');
    const platform = getPlatform(navigator && navigator.userAgent);

    if (!platform || !(androidStoreLink || iosStoreLink) || !appLink) {
      window.location = link;
      return;
    }

    const appStoreLinkRedirect = platform === 'android' ? androidStoreLink : iosStoreLink;

      /*
          cannot detect whether the app is installed from the browser so the delayed redirect
          will point the user to the app store link if it hasn't already redirected to the app
      */

    setTimeout(() => window.location = appStoreLinkRedirect, 30);
    window.location = appLink.replace('%s', channelId);
  };
}

const getPlatform = userAgent => {
  if (!userAgent) {
    return null;
  }

  const lower = userAgent.toLowerCase();
  if (lower.includes('android')) {
    return 'android';
  }

  if (lower.includes('iphone')) {
    return 'iphone';
  }

  return null;
};
